import { useData } from '@app/data/repositories';
import { DocumentsScreen } from './DocumentsScreen';
import { useDocuments } from './useDocuments';

/**
 * Вход библиотеки документов: знает про данные и навигацию, сам экран — нет.
 * Та же граница, что у `DocumentsRoute` и `DocumentsScreen` на Android.
 */
export function DocumentsRoute({
  caseId,
  onBack,
  onOpenDocument,
}: {
  caseId: string;
  onBack: () => void;
  onOpenDocument?: (id: string) => void;
}) {
  const { db, files } = useData();
  const { state, actions } = useDocuments(caseId, db, files);

  return (
    <DocumentsScreen
      state={state}
      actions={actions}
      onBack={onBack}
      onOpenDocument={onOpenDocument}
    />
  );
}
